import PropTypes from 'prop-types';

import { asArray as statusesAsArray } from '../constants/statuses';
import { asArray as subscriptionSources } from '../constants/subscriptionSources';
import { subscriptionDeliveryPropType } from './delivery';
import { deviationPropType } from './deviations';

export const statusPropType = PropTypes.oneOf(statusesAsArray);

export const productPropType = PropTypes.shape({
    activeSince: PropTypes.string,
    billingPeriod: PropTypes.string,
    description: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
    })),
    id: PropTypes.string,
    image: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string.isRequired,
    })),
    name: PropTypes.string,
    price: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }),
    renewPeriod: PropTypes.string,
    renewPrice: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }),
    subscriptionPeriod: PropTypes.string,
});

const money = PropTypes.shape({
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
});

export const paymentPropType = PropTypes.shape({
    paymentMethod: PropTypes.shape({
        text: PropTypes.oneOf([
            'Master Card',
            'Visa',
            'Klarna',
            'Strex',
            'WyWallet',
            'iTunes',
            'Telenor',
            'Vipps',
            'American Express',
            'Telia',
            'NTM Media',
            'UNT',
            'Storytel - Omnipaket.se',
            'Ålcom',
            'Swish',
            'SMS',
        ]),
    }),
    paymentIconType: PropTypes.oneOf([
        'mc',
        'visa',
        'klarna',
        'strex',
        'wywallet',
        'itunes',
        'telenor',
        'vipps',
        'amex',
        'telia',
        'ntm',
        'unt',
        'storytel',
        'alcom',
        'swish',
        'sms',
    ]),
    paymentDetail: PropTypes.string,
    actionUrl: PropTypes.string,
    status: PropTypes.oneOf([
        'INVALID_PAYMENT',
        'VALID_PAYMENT',
        'PRESENT_CARD',
        'DELETED_CARD',
        'GIFT',
    ]),
    source: PropTypes.oneOf([
        'SPID',
        'ITUNES',
        'TELENOR',
    ]),
    nextBillDay: PropTypes.string,
    type: PropTypes.oneOf([
        'MasterCard',
        'Visa',
        'Klarna',
        'KLARNA_DIRECT',
        'Strex',
        'WyWallet',
        'Apple',
        'Telenor',
        'MC',
        'VIPPS_RECURRING',
        'AMEX',
        'TELIA',
        'NTM',
        'UNT',
        'BUNDLERSTORYTEL',
        'BUNDLERALCOM',
        'SWISH',
        'FORTUMO_DIRECT',
    ]),
    expiryDate: PropTypes.string,
    nextBilling: PropTypes.shape({
        date: PropTypes.string,
        price: money,
        lackReason: PropTypes.oneOf([
            'NoMore',
            'Free',
            'TooFarAhead',
        ]),
        previewPeriod: PropTypes.string,
    }),
    nonInstant: PropTypes.bool,
    recurringBilling: PropTypes.shape({
        price: money,
    }),
    creditBalance: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }),
});

export const subscriptionPropType = PropTypes.shape({
    actions: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string.isRequired,
        url: PropTypes.string,
    })),
    alerts: PropTypes.arrayOf(PropTypes.string),
    clientId: PropTypes.string,
    delivery: subscriptionDeliveryPropType,
    deviations: PropTypes.shape({
        data: PropTypes.arrayOf(deviationPropType),
        fetched: PropTypes.bool,
    }),
    disabledActions: PropTypes.arrayOf(PropTypes.string),
    id: PropTypes.string,
    payment: paymentPropType.isRequired,
    product: productPropType.isRequired,
    reactivateFromId: PropTypes.string,
    sharingStatus: PropTypes.oneOf([
        'ACCEPTED',
        'UNACCEPTED',
    ]),
    source: PropTypes.oneOf(subscriptionSources),
    status: statusPropType.isRequired,
});
